export class Search {
    static SearchFilter = class {
        field: string;
        op: string;
        value: string;
    }
}
  


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/search.model.ts